var _linearGradient, _linearGradient2, _radialGradient, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 228,
    viewBox: "0 0 312 228",
    width: 312,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 229.49,
    x2: 203.171,
    y1: 1.03715,
    y2: 209.575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302d4c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 213.887,
    x2: 139.817,
    y1: 7.84968,
    y2: 195.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c344ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d666a9"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-43.0537136 67.07335068 -67.07335068 -43.0537136 132.221 150.748)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f78f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#faa548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f5d743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb447"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 151.841,
    x2: 170.943,
    y1: 169.834,
    y2: 203.059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f78f49"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 217.151,
    x2: 121.942,
    y1: 194.986,
    y2: 170.302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#404477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2a2e64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474c89"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 190.389,
    x2: 117.639,
    y1: 159.452,
    y2: 185.396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32366d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#585ea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32366d"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 107.783,
    x2: 106.787,
    y1: 127.069,
    y2: 113.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e89650"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 105.917,
    x2: 110.739,
    y1: 146.709,
    y2: 171.191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab7ff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e71e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m155.896 227.811c77.263 0 139.897-6.406 139.897-14.309s-62.634-14.309-139.897-14.309c-77.2623 0-139.896 6.406-139.896 14.309s62.6337 14.309 139.896 14.309z",
    fill: "#dae1e8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m268.92 8.9366c.252-2.21531-.457-4.43252-1.948-6.09004-1.491-1.65751-3.622-2.596652-5.851-2.579232-22.532.176847-81.674.640361-97.556.764952-2.27.01779-4.173 1.72226-4.44 3.97734-3.016 25.49428-19.724 166.73238-22.957 194.06238-.142 1.205.207 2.416.969 3.361.762.944 1.872 1.541 3.08 1.656 17 1.616 76.483 7.272 97.724 9.292 4.225.402 7.995-2.654 8.475-6.871 3.741-32.846 18.518-162.5767 22.504-197.5734z",
    fill: "#181233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.73 5.30381c.146-1.28261-.264-2.56636-1.127-3.52595-.863-.959969-2.096-1.503763-3.386-1.493539-18.846.147688-84.412.661569-101.261.793729-2.269.0178-4.171 1.72075-4.44 3.97507-3.024 25.44058-19.76 166.20588-23.005 193.49388-.143 1.205.206 2.417.968 3.362.762.944 1.873 1.542 3.082 1.657 17.96 1.707 83.31 7.921 100.929 9.597 2.445.232 4.625-1.535 4.904-3.974 3.136-27.399 19.986-174.6222 23.336-203.88519z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.522 3.88775c-.563.0046-1.035.4256-1.108.98502-.253 1.99841-.809 6.36673-.809 6.36673-.364 3.0747-2.964 5.3945-6.062 5.409-11.571.0533-38.653.1783-51.118.2358-1.687.0077-3.303-.6798-4.467-1.9006-1.165-1.2208-1.775-2.8673-1.688-4.5524 0 0 .27-3.02026.426-4.76638.028-.30981-.076-.61693-.287-.84622-.21-.2289-.508-.3585-.818-.35735-3.5.01611-13.361.06097-13.361.06097-2.024.01648-3.721 1.53561-3.96 3.54629-2.835 23.84449-19.215 161.59839-22.254 187.15539-.127 1.074.183 2.154.861 2.996s1.667 1.376 2.743 1.481c16.642 1.619 79.173 7.704 95.53 9.296 2.182.212 4.133-1.365 4.382-3.545 2.945-25.709 19.452-169.7787 22.596-197.21966.13-1.14453-.234-2.28982-1.005-3.14639s-1.871-1.34161-3.025-1.3324c0 0-12.872.10429-16.576.1342z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.75 28.149c.151-1.2782-.253-2.5598-1.108-3.5213-.856-.9616-2.081-1.5116-3.368-1.5115-16.778.0032-70.298.0135-85.405.0163-2.284.0004-4.206 1.7094-4.475 3.9778-1.608 13.6017-6.887 58.2359-8.63 72.9797-.147 1.237.226 2.48 1.028 3.433.803.953 1.964 1.531 3.208 1.597 16.322.869 69.514 3.702 84.929 4.523 2.375.127 4.439-1.613 4.716-3.975 1.694-14.4217 7.27-61.896 9.105-77.519z",
    fill: "#fdfdfd",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.958 37.2144c.163-1.284-.233-2.5762-1.089-3.5473s-2.088-1.5275-3.382-1.5275c-14.876.001-57.91.0039-71.284.0048-2.288.0001-4.213 1.7148-4.477 3.9877-.484 4.1733-1.244 10.7318-1.766 15.2259-.146 1.2616.247 2.5263 1.082 3.4831s2.035 1.5169 3.305 1.5423c14.646.2941 57.532 1.1552 70.935 1.4243 2.304.0462 4.271-1.6526 4.562-3.9384.57-4.4922 1.495-11.7737 2.114-16.6549z",
    fill: "#fdfdfd",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.889 69.4439c.145-1.2562-.245-2.5153-1.074-3.47s-2.021-1.5172-3.285-1.5503c-14.524-.3803-57.024-1.4929-70.489-1.8454-2.342-.0613-4.341 1.6819-4.598 4.0104-.146 1.3187-.308 2.7907-.459 4.1556-.138 1.247.25 2.4951 1.071 3.4439.821.9489 2 1.5126 3.254 1.5555 14.44.4948 56.922 1.9504 70.405 2.4124 2.348.0804 4.364-1.6559 4.632-3.9896.171-1.4865.366-3.1775.543-4.7225z",
    fill: "#fdfdfd",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.334 90.5133c.16-1.2533-.213-2.5163-1.029-3.4812s-1.999-1.543-3.261-1.5935c-7.704-.3082-22.485-.8996-29.703-1.1884-2.354-.0941-4.383 1.6402-4.657 3.98-.251 2.1454-.558 4.7748-.819 7.0042-.144 1.2368.229 2.4783 1.032 3.43s1.964 1.5286 3.207 1.5946c7.621.402 22.367 1.18 29.579 1.56 2.356.124 4.409-1.589 4.708-3.9295.287-2.2441.643-5.0287.943-7.3762z",
    fill: "#25ff00",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.907 88.7686c.143-1.2522-.245-2.5071-1.07-3.4602s-2.011-1.5172-3.271-1.5556c-7.009-.2133-19.782-.6021-26.377-.8029-2.362-.0719-4.378 1.6918-4.621 4.0418-.198 1.917-.434 4.2005-.638 6.1841-.128 1.2346.259 2.4672 1.07 3.407.811.9399 1.973 1.5037 3.213 1.5587 6.933.3071 19.675.8716 26.27 1.1638 2.366.1048 4.409-1.639 4.677-3.9918.23-2.0157.507-4.446.747-6.5449z",
    fill: "#ff0014",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.2815 159.703c-1.5102-29.742 17.086-71.4777 35.5589-69.9467 17.5296 1.4553 9.7916 11.6007 28.0556 33.6197 18.3 22.065 31.826 37.775 43.275 48 11.161 9.968 55.206 20.907 14.951 39.732-36.068 16.867-59.021 9.915-74.853 7.867-15.8313-2.049-45.0366-20.848-46.9875-59.272z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.36 162.451c7.973-.068 18.001 2.854 24.798 8.925 9.73 8.69 44.461 18.121 26.517 32.871-.809-.612-1.599-1.247-2.374-1.856-4.109-3.236-8.312-6.479-13.2-8.49-13.446-5.534-20.359-3.289-33.73-1.354-2.676.386-8.822-.132-11.423-1.047-13.809-4.846-15.801-16.468-13.623-20.202 4.581-7.855 15.063-8.783 23.035-8.847z",
    fill: "#9b4408",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.2815 159.703c-1.5102-29.742 17.086-71.4777 35.5589-69.9467 17.5296 1.4553 9.7916 11.6007 28.0556 33.6197 18.3 22.065 31.826 37.775 43.275 48 11.161 9.968 55.206 20.907 14.951 39.732-36.068 16.867-59.021 9.915-74.853 7.867-15.8313-2.049-45.0366-20.848-46.9875-59.272z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.927 195.407c-1.209-.899-2.604.832-.846 2.329.632.54 1.254 1.111 1.9 1.81.943 1.029 1.697 2.423 2.537 3.535.681.903 1.757 2.362 3.122 1.217.186-.155 1.892-2.223 2.041-2.416 2.618-3.345-1.259-3.012-3.406-3.031-.773-.008-2.025-.93-3.081-1.705-.89-.65-1.362-1.066-2.267-1.739z",
    fill: "#f7a15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.669 202.984c.414-.261.863-.567 1.022-.749.392-.442.736-.967.94-1.527.231-.631.238-2.034.732-2.525.598-.597 1.58-.389 2.363-.631.835-.261 1.873-.836 2.44-1.244 1.96-1.414 3.123-2.472 5.032-3.893.747-.556 1.532-1.316 2.457-1.46.312-.045.805-.094 1.016.205.24.34.042.979-.13 1.3-.55 1.028-1.495 1.932-2.241 2.82-2.549 3.035-5.351 5.84-7.983 8.8-.698.786-2.167 2.967-3.058 3.364-.321.144-.728-.185-.999-.363-.877-.57-1.438-1.625-1.815-2.57-.251-.635-.551-1.319.224-1.527z",
    fill: "#742f5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.789 194.271c-7.829-7.681-21.78-19.305-33.353-23.527s-36.774-8.347-44.018-7.942c-24.609 1.365-25.233 12.856-7.514 19.819 17.543 6.891 35.42.786 48.922 2.555 13.9 1.818 26.984 7.213 32.5 12.501 3.017 2.888 3.864 1.875 4.566 1.191 1.918-1.868.797-2.733-1.103-4.597z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.901 166.922c-1.327.283-4.69 1.705-6.039.132-.578-.669-.504-1.618.046-2.26.551-.647 1.893-1.055 3.178-1.112 2.375-.109 4.543-1.595 6.16-1.931 1.187-.246 2.259-.046 3.385.472.561.257 1.024.855.922 1.535-.19 1.266-1.4 1.886-2.401 2.446-1.137.631-3.961.446-5.251.718z",
    fill: "#742f5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.255 167.39c-.665-.132-1.605-1.187-.576-1.894.353-.245 1.295-.366 1.724-.366 1.043.007 2.519-.208 3.676-.136.503.03 1.158.495 1.111 1.096-.063.79-1.063.975-1.665 1.07-1.371.219-3.002.476-4.27.23z",
    fill: "#f7a15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.272 172.883c-3.512 3.273-5.999 12.538 5.695 17.293 11.694 4.756 16.88 2.945 29.401-2.131 12.521-5.077 20.891-14.21 26.386-16.86 5.495-2.646 8.019-2.226 10.161-2.725.714-.17 1.4-.004 1.409-1.656.009-1.78-.365-1.871-2.575-2.835-4.053-1.777-10.673-3.98-21.015-1.285-10.471 2.729-19.782 10.546-32.283 9.911-8.349-.423-12.161-4.392-17.179.288z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.043 111.121c-.846.31-2.025 1.251-1.651 3.61.175 1.104.522 2.234.747 3.326.368 1.8.083 4.064.144 5.894.035 1.039.047 5.447 2.468 5.141 2.363-.303 2.36-2.964 2.395-4.007.042-1.293.009-2.76-.004-4.053-.017-1.67-.077-3.383-.249-5.046-.132-1.274-.527-2.797-1.22-3.901-.478-.76-1.773-1.281-2.63-.964z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.633 110.975c.083.982-.204 2.366-.283 2.903-.186 1.258-.804 3.375-1.133 4.608-.15.563-.377 1.24-.946 1.504-2.239 1.051-3.942-.128-4.952-2.139-.201-.397-.86-1.83-1.347-2.212-.532-.419-.755-.642-.894-1.334-.173-.862.416-2.794.918-3.376 1.309-1.519 3.537-2.472 5.562-2.268 1.509.151 2.935.631 3.075 2.314z",
    fill: "#f3b376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.397 110.76c-.099.842.019 2.646.371 3.292.11.2.308.635.575.665.484.049.89-1.024 1.091-1.345.632-1.01 1.473-1.762 2.654-2.042 1.084-.257 1.841.008 2.739.616.78.53 1.586 1.354 2.626 1.203 1.004-.144 1.91-1.46 2.399-2.295 1.08-1.845 1.165-4.03 1.016-6.112-.06-.847-.245-1.819-.76-2.518-.548-.745-1.178-.37-1.532.306-.953 1.435-1.455 2.017-2.234 2.574-.677.483-1.31.842-2.094 1.12-.866.308-1.533.294-2.32.393-2.212.272-4.272 1.943-4.531 4.143z",
    fill: "#693474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.134 162.812c1.152 3.452-8.492 5.209-12.55 9.322-5.135 5.201-9.968 10.72-14.1 11.643-3.813-4.763-2.732-1.482-5.763-3.554-24.0932-16.488-23.4146-34.648-22.7066-40.276 2.0953-16.655 17.2476-19.736 17.2666-19.203.038 1.107-.456 3.761 2.868 3.587 2.54-.132 1.768-2.971 1.978-3.685.459-.28 16.394-.163 26.323 23.852 2.656 6.422 4.831 12.761 6.684 18.314z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.199 134.731c-2.535-5.878-6.778-19.154 10.278-6.002 11.306 8.996 16.162 19.357 18.338 26.983.928 3.256 1.368 5.627 1.432 7.315-1.759-.146-3.154-.199-5.083-.217-.465-.837-.934-1.801-1.321-2.795-2.54-6.527-5.771-10.973-9.597-15.703-2.985-3.695-9.953-.086-14.047-9.581z",
    fill: "#ab7ff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.862 164.049c-.199.011-.389-.081-.507-.239-.118-.164-.149-.371-.082-.556.968-2.719 3.997-11.219 4.684-13.143.084-.239.305-.397.555-.397 1.168-.022 4.501-.077 6.059-.099.192-.005.373.082.488.24.115.153.151.349.095.534-.797 2.621-3.346 11.001-3.938 12.952-.074.24-.294.414-.548.425-1.271.049-5.067.213-6.806.283z",
    fill: "#2b2650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.901 163.473c-.618.245-3.665 1.493-4.354.374-1.147-1.86 1.512-2.593 2.575-3.058.77-.337 1.774-.658 2.38-1.187 1.337-1.168 1.142-1.732 2.933-2.329.715-.238 3.444-.446 3.779-.446 1.108 0 1.737.015 2.227.994.149.299.173 1.898.047 2.151-.249.499-.981.945-1.478 1.195-.895.446-2.194.812-2.879.877-.926.083-2.297.559-3.109.748-.7.163-1.437.408-2.121.681z",
    fill: "#f7a15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.4996 135c-3.4995 7-3.0255 20.202.1115 27.206 1.9196 4.283 4.6284 7.682 12.4169 7.814 7.788.136 14.428-2.219 17.071-3.625 2.764-1.471 4.451-1.618 3.423-4.018-1.016-2.374-1.024-1.985-5.55-1.815-5.801.212-14.527 1.3-14.286-9.526.397-17.774-10.0583-20.5-13.1864-16.036z",
    fill: "#ab7ff2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.69718e7c9fa0dacb4ed7cdac4b8b28ea.svg";
export { ForwardRef as ReactComponent };